import { render, staticRenderFns } from "./v-checkbox.vue?vue&type=template&id=6a47d3ec&scoped=true"
import script from "./v-checkbox.vue?vue&type=script&lang=js"
export * from "./v-checkbox.vue?vue&type=script&lang=js"
import style0 from "./v-checkbox.vue?vue&type=style&index=0&id=6a47d3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../com-tool/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a47d3ec",
  null
  
)

export default component.exports